import { render } from "./ClaimDetails.vue?vue&type=template&id=e44ad182"
import script from "./ClaimDetails.vue?vue&type=script&lang=js"
export * from "./ClaimDetails.vue?vue&type=script&lang=js"
/* custom blocks */
import block0 from "./ClaimDetails.i18n.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Ftmp%2Fbuild_6d8875c6%2Fpackages%2Fstore%2Fsrc%2Fcomponents%2Fclaim%2Fdetails%2FClaimDetails.vue&external"
if (typeof block0 === 'function') block0(script)


import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__